import $i18n from 'panda-i18n';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, APP_MODE } from 'ice';
import { Button, Dialog, Icon, Nav } from '@fpxfd/next';
import { asideMenuConfig } from '../../menuConfig';
import store from '@/store';
import { AE_SCREEN_URL } from '@/config';
import styles from '../../index.module.scss';
import { getSessionToJson, getSingleDict } from '@/utils/getDict';

import { SWITCH_URL } from '@/config/switchVersionUrl';
import { getCainiaoPackageUrl } from '@/utils';

const { SubNav } = Nav;
const NavItem = Nav.Item;

// mock the auth object
// Ref: https://ice.work/docs/guide/advance/auth#%E5%88%9D%E5%A7%8B%E5%8C%96%E6%9D%83%E9%99%90%E6%95%B0%E6%8D%AE
const AUTH_CONFIG = {
  admin: true,
  guest: false,
};

export interface IMenuItem {
  name: string;
  path: string;
  icon?: string;
  children?: IMenuItem[];
}

// 上传轨迹到百度埋点
const uploadTrack = ({ name, link }: any) => {
  const users = JSON.parse(localStorage.getItem('user') || '{}');

  const info = {
    userName: users?.userName || users?.empCode || '',
    link,
  };
  const time = `操作时间: ${new Date()}`;
  // @ts-ignore
  window._hmt.push(['_trackEvent', name, time, JSON.stringify(info)]);
};

function getNavMenuItems(menusData: any[], initIndex?: number | string, auth?: any) {
  if (!menusData) {
    return [];
  }

  return menusData
    .filter((item) => {
      let roleAuth = true;
      // if item.roles is [] or undefined, roleAuth is true
      if (auth && item.auth && item.auth instanceof Array) {
        if (item.auth.length) {
          roleAuth = item.auth.some((key) => auth[key]);
        }
      }
      return item.name && !item.hideInMenu && roleAuth;
    })
    .map((item, index) => {
      return getSubMenuOrItem(item, `${initIndex}-${index}`, auth);
    });
}

const getPath = (item) => {
  return item.path === '/service/AE' ? (
    <span
      onClick={() => {
        window.open(AE_SCREEN_URL);
      }}
    >
      {item.name}
    </span>
  ) : (
    <Link to={item.path} onClick={() => uploadTrack({ name: item.name, link: item.path })}>
      {item.name}
    </Link>
  );
};
function getSubMenuOrItem(item: IMenuItem, index?: number | string, auth?: any) {
  if (item.children && item.children.some((child) => child.name)) {
    const childrenItems = getNavMenuItems(item.children, index, auth);
    if (childrenItems && childrenItems.length > 0) {
      const subNav = (
        <SubNav
          key={item.name}
          // icon={<Icon type={item.icon} size="small" style={{ marginRight: '12px', verticalAlign: 'middle' }} />}
          icon={<i className={`iconfont icon${item.icon} menuIcon`} />}
          label={item.name}
        >
          {childrenItems}
        </SubNav>
      );

      return subNav;
    }
    return null;
  }

  const navItem = (
    <NavItem key={item.path} icon={item.icon}>
      {getCainiaoPackageUrl(item.path) ? (
        <a onClick={() => window.open(getCainiaoPackageUrl(item.path), '_blank')}>{item.name}</a>
      ) : (
        getPath(item)
      )}
    </NavItem>
  );

  return navItem;
}

function getFinalUrl(path: string) {
  const fromNewVersionStroage: any = window.localStorage.getItem('fromNewVersion'); // 还没过期
  if (fromNewVersionStroage && fromNewVersionStroage > new Date().getTime()) {
    return ''; // 继续停留在当前页面
  }
  const urlConfigList = getSingleDict('urlConfigList');
  let url = '';
  urlConfigList?.map((item) => {
    if (path === item.oldMenuUrl) {
      const { newMenuUrl } = item;
      const wholeUrl = !!(newMenuUrl.startsWith('https://') || newMenuUrl.startsWith('https://'));
      url = wholeUrl
        ? newMenuUrl
        : APP_MODE === 'dev'
        ? `//localhost:7200${newMenuUrl}`
        : `${window.location.origin}/cone/giws${newMenuUrl}`;
    }
  });

  return url;
}
let hasNewurl = false;
const Navigation = (props, context) => {
  const [openKeys, setOpenKeys] = useState<string[] | string>([]);
  const [asideMenu, setAsideMenu] = useState(asideMenuConfig);

  const { pathname } = window.location;
  const { isCollapse } = context;
  const [user] = store.useModel('user');
  const [permission] = store.useModel('permission');

  useEffect(() => {
    const curSubNav = asideMenu[user.menu]
      ? asideMenu[user.menu].find((menuConfig) => {
          return menuConfig.children && checkChildPathExists(menuConfig);
        })
      : [];

    function checkChildPathExists(menuConfig) {
      return menuConfig.children.some((child) => {
        return child.path === pathname ? child.path === pathname : child.children && checkChildPathExists(child);
      });
    }

    if (curSubNav && !openKeys.includes(curSubNav.name)) {
      setOpenKeys([...openKeys, curSubNav.name]);
    }
    const newUrl = getFinalUrl(pathname);
    if (pathname && newUrl) {
      if (hasNewurl) {
        return;
      }
      hasNewurl = true;
      Dialog.confirm({
        title: $i18n.get({ id: 'picture_prompt', dm: '提示' }),
        content: $i18n.get({ id: 'AreYouSureYouWantToJumpTo', dm: '确定要跳转至新版吗?' }),
        onOk: () => {
          location.replace(newUrl);
        },
        onCancel: () => {
          hasNewurl = false;
        },
      });
    }
  }, [pathname, user]);

  useEffect(() => {
    setAsideMenu(permission.usePermission ? permission.menuConfig : asideMenuConfig);
  }, [permission.menuConfig, permission.usePermission, permission]);

  return (
    <Nav
      type="normal"
      openKeys={openKeys}
      selectedKeys={[pathname]}
      defaultSelectedKeys={[pathname]}
      embeddable
      activeDirection="right"
      iconOnly={isCollapse}
      hasArrow={false}
      mode={isCollapse ? 'popup' : 'inline'}
      onOpen={(keys) => setOpenKeys(keys)}
      openMode={'single'}
      className={styles.navContent}
    >
      {getNavMenuItems(asideMenu[user.menu], 0, AUTH_CONFIG)}
    </Nav>
  );
};

Navigation.contextTypes = {
  isCollapse: PropTypes.bool,
};

export default Navigation;
